/**
 * All partner logos under src/assets/images/Partners (sorted by filename).
 * Uses require.context so new files in that folder are picked up automatically.
 */
const partnerLogosContext = require.context(
  "../assets/images/Partners",
  false,
  /\.(webp|png|jpe?g|gif|svg|avif)$/i,
);

function resolveAsset(mod) {
  if (typeof mod === "string") return mod;
  if (mod && typeof mod === "object" && "default" in mod) return mod.default;
  return mod;
}

export const PARTNER_LOGOS = partnerLogosContext
  .keys()
  .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
  .map((key) => resolveAsset(partnerLogosContext(key)));
